import { BaseComponent } from '@glidecms/deliver-core-dev/types'
import {
  IPageContext,
  SERVICE_TYPES,
  ISettingsService,
} from '@glidecms/deliver-core-dev/types/services'

export const viewAllIcon = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Article-template-exploration" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Which-grid-–-Articles-–-Tablet-L" transform="translate(-500.000000, -1395.000000)" fill="#0065C9">
            <g id="Group-4" transform="translate(427.000000, 1387.000000)">
                <polygon id="arrow-bold-down" transform="translate(80.606061, 13.000000) rotate(-270.000000) translate(-80.606061, -13.000000) " points="76 7.15354915 77.6200627 5.61904762 85.2121212 13.046035 77.6200627 20.3809524 76 18.8157608 82.0037618 13.015345"></polygon>
            </g>
        </g>
    </g>
</svg>`

const hideIcon = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="15px" height="10px" viewBox="0 0 15 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Article-template-exploration" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Which-grid-–-Articles-–-Tablet-L" transform="translate(-500.000000, -1395.000000)" fill="#0065C9">
            <g id="Group-4" transform="translate(427.000000, 1387.000000)">
                <polygon id="arrow-bold-down" transform="translate(80.606061, 13.000000) rotate(-90) translate(-80.606061, -13.000000) " points="76 7.15354915 77.6200627 5.61904762 85.2121212 13.046035 77.6200627 20.3809524 76 18.8157608 82.0037618 13.015345"></polygon>
            </g>
        </g>
    </g>
</svg>`

export const downArrow = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="15px" height="14px" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Buttons-and-Links" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Buttons-and-links" transform="translate(-819.000000, -614.000000)" fill="#1866C2" fill-rule="nonzero">
            <g id="Links---header/jumplinks" transform="translate(679.000000, 563.000000)">
                <g id="Become-a-member---members" transform="translate(0.000000, 47.000000)">
                    <g id="arrow-down" transform="translate(137.500000, 1.000000)">
                        <polygon id="Path" points="16.6666667 10 15.4916667 8.825 10.8333333 13.475 10.8333333 3.33333333 9.16666667 3.33333333 9.16666667 13.475 4.51666667 8.81666667 3.33333333 10 10 16.6666667"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`

export default class WSJumpLinks extends BaseComponent {
  public async render(_, context: IPageContext): Promise<string> {
    const template = require('./w-jump-links.component.handlebars')

    const settingsService = context.getService<ISettingsService>(SERVICE_TYPES.ISettingsService)
    const analyticSettings = settingsService.getGoogleAnalyticSettings()
    const { trackingId = '' } = analyticSettings

    return template({
      downArrow,
      viewAllIcon,
      hideIcon,
      trackingId,
    })
  }
}
